import { gql } from '@apollo/client/core';

const RenewActiveJobStatusMutation = gql`
  mutation renewActiveJobStatus($input: RenewActiveJobStatusInput!) {
    renewActiveJobStatus(input: $input) {
      id
      warRoomJobSearchStatus
      warRoomJobSearchStatusExpiredAt
    }
  }
`;

export default RenewActiveJobStatusMutation;
